import { createContext } from "react";

const ReconciliationBankNotesContext = createContext();

export default ReconciliationBankNotesContext;